const { logger } = require('@fiverr-private/obs');

/**
 * The error message thrown when trying to make a specific project API call without attributing it to a project.
 * @type {String}
 */
const NO_PROJECT_ID_ERROR = 'No projectId was given.';

/**
 * The error message thrown when trying to fetch user data without attributing it to a project.
 * @type {String}
 */
const NO_USER_ID_ERROR = 'No userId was given.';

const handleAPIValidationError = (apiName, message) => {
    const error = new Error(`${apiName} - ${message}`);

    logger.error(error);

    return Promise.reject(error);
};

module.exports = {
    NO_PROJECT_ID_ERROR,
    NO_USER_ID_ERROR,
    handleAPIValidationError
};
